import { Component, OnInit } from '@angular/core';
import { UtilService } from '../../services/util.service';
import { AuthService } from '../../services/auth.service';

declare var jQuery:any; 
@Component({
  selector: 'app-tutorial',
  templateUrl: './tutorial.component.html',
  styleUrls: ['./tutorial.component.scss']
})
export class TutorialComponent implements OnInit {
  pageNumber:Number=0;
  constructor(private utilService:UtilService, private authService:AuthService) { }

  ngOnInit() {
    this.utilService.userDetails().subscribe(res => {
      if(res.triggers.first_login) {
        jQuery('#tutorialModal').modal('show');
        this.updateTriggers(true);
      }
    });
  }

  updateTriggers(status) {
    this.authService.updateUserTriggers(status).subscribe(res=>{
    });
  }

  navigate(value?) {
    if(value == 'close') {
      this.updateTriggers(false);
    }
    if(value == 'close' || this.pageNumber == 3) {
      jQuery('#tutorialModal').modal('hide');
    }else {
      if(this.pageNumber <3) {
        this.pageNumber = +this.pageNumber+1;
      }
    }
  }

}



// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/tutorial/tutorial.component.ts